<script>
export default {
  name: 'IntelligenceV2PainelTurnoDetalhes',
  props: {
    // Turno já decorado por `decorarTurno`: leitura, itens com chip e rótulo em
    // português, frase da réplica e condição da rodada 3.
    turno: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <!-- O lado ESTRUTURADO do turno. Quando o especialista tem fala (P10), isto
       vira o detalhe dela e mora dentro de "ver análise completa"; sem fala,
       é o próprio corpo do turno — o comportamento de sempre. -->
  <div class="painel-turno-detalhes az-gap-xsmall">
    <div
      v-if="turno.leitura"
      class="az-text-secondary az-size-12 painel-turno-detalhes__linha"
    >
      {{ turno.leitura }}
    </div>

    <div
      v-for="item in turno.itens"
      :key="item.chave"
      class="d-flex align-start flex-wrap az-gap-small"
    >
      <BaseStatus
        soft
        preserve-case
        :content="item.rotulo"
        :color="item.cor"
        class="flex-shrink-0"
      />
      <div class="painel-turno-detalhes__texto-item">
        <span class="az-text-secondary az-size-12">{{ item.texto }}</span>
        <span v-if="item.norma" class="az-text-secondary az-size-12 az-muted">
          — {{ item.norma }}
        </span>
      </div>
    </div>

    <div v-if="turno.frase" class="az-text-secondary az-size-12 painel-turno-detalhes__linha">
      {{ turno.frase }}
    </div>

    <div v-if="turno.ehCondicao" class="az-text-secondary az-size-12 painel-turno-detalhes__linha">
      {{ turno.condicao }}
    </div>
  </div>
</template>

<style lang="sass" scoped>
.painel-turno-detalhes
  display: flex
  flex-direction: column

.painel-turno-detalhes__linha
  line-height: 1.45

// Piso de largura: o chip da classe é `flex-shrink-0` e, sem o piso, o texto ao
// lado cede até sobrar um caractere por linha no drawer de 251px.
.painel-turno-detalhes__texto-item
  flex: 1 1 160px
  min-width: 160px
</style>
